import verificationCodeImg from '@/mixin/verification-code-img';
export default {
  name: 'ValidateCodePageCpt',
  mixins: [verificationCodeImg],
  components: {},
  data() {
    return {
      btnLoading: false,
      show: false,
      productId: '',
      openDate: '',
      form: {
        validateCode: ''
      }
    };
  },
  mounted() {
    //console.log('---code-mounted---', this.productId)
    //this.onFreshCodeClickForAppointment({productId: this.productId, openDate: this.openDate})
  },
  methods: {
    showView(params) {
      //console.log('----showView-params---', params)
      this.productId = params.productId;
      this.openDate = params.openDate;
      this.onFreshCodeClickForAppointment({
        productId: this.productId,
        openDate: this.openDate
      });
      this.show = true;
    },
    buttonClick() {
      this.$emit('selected', {
        validateCode: this.form.validateCode,
        uuid_key: this.codeUuidKey
      });
      this.show = false;
      this.form.validateCode = '';
    }
  }
};